import ApiService from '@/common/api.service'
import AuthService from '@/common/auth.service'
import PromoService from '@/common/promo.service'
import {
  LOGIN,
  LOGOUT,
  CHECK_AUTH,
  RESET_ERRORS
} from './actions.type'
import { SET_AUTH, SET_OPERATOR, PURGE_AUTH, SET_ERROR, PURGE_ERRORS } from './mutations.type'

const state = {
  errors: null,
  user: AuthService.getOperator() || {},
  isAuthenticated: !!AuthService.getOperator()
}

const getters = {
  currentOperator (state) {
    return state.operator
  },
  isAuthenticated (state) {
    return state.isAuthenticated
  }
}

const actions = {
  [LOGIN] (context, credentials) {
    return new Promise((resolve, reject) => {
      ApiService.call('login', {
        'userData': {
          'phone': credentials.phone,
          'password': credentials.password
        }
      })
        .then(({ data }) => {
          if (data.success) {
            context.commit(SET_AUTH, data.userData)
            resolve(data.userData)
          } else {
            context.commit(SET_ERROR, data.warnings)
            reject(data)
          }
        })
        .catch(error => {
          reject(error)
          alert(error.message)
        })
    })
  },
  [LOGOUT] (context) {
    context.commit(PURGE_AUTH)
  },
  [RESET_ERRORS] (context) {
    context.commit(PURGE_ERRORS)
  },
  [CHECK_AUTH] (context) {
    let user = AuthService.getOperator()
    if (user) {
      ApiService.call('currentuser', {
        'userData': {
          'userId': user.userId,
          'secretKey': user.secretKey
        }
      })
        .then(({data}) => {
          if (data.success) {
            context.commit(SET_OPERATOR, data.userData)
            context.commit(SET_AUTH, user)
          } else {
            context.commit(PURGE_AUTH)
          }
        })
    } else {
      context.commit(PURGE_AUTH)
    }
  }
}

const mutations = {
  [SET_ERROR] (state, error) {
    state.errors = error
  },
  [PURGE_ERRORS] (state) {
    state.errors = {}
  },
  [SET_AUTH] (state, operator) {
    state.isAuthenticated = true
    AuthService.saveOperator(operator)
  },
  [SET_OPERATOR] (state, operator) {
    state.operator = operator
  },
  [PURGE_AUTH] (state) {
    state.isUserAuthenticated = false
    state.user = {}
    AuthService.destroyUser()
    PromoService.removePromo()

    state.isAuthenticated = false
    state.operator = {}
    state.errors = {}
    AuthService.destroyOperator()
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/operator.module.js